import _                         from 'underscore';
import React, { FC, useContext } from 'react';
import { useQuery }              from "@apollo/react-hooks";

import { formatOption, IFormatOptionValue }            from '@src/util';
import { CorvalProject, PreSelectedSelectField, Uuid } from '@src/types';
import { SelectField }                                 from '@src/views/components/forms';
import { queriesHaveData, queriesLoading }             from "@src/store/_apolloUtil";
import { ProjectQueries }                              from "@src/queries/ProjectQueries";
import { ProjectContext }                              from "@src/views/pages/projects/ProjectIndexPage";


interface Props extends PreSelectedSelectField {
    projectId?: Uuid,
}

const defaultProps: Props = {
    projectId: null,
};

const Dropdown: FC<Props> = ( props ) => {

    const projectContext = useContext( ProjectContext ),
          projectId      = projectContext?.projectId ?? props?.projectId;

    const getProjectVersionReq = useQuery<{ projects: CorvalProject[] }>(
        ProjectQueries.queries.GET_PROJECT( `id projectVersions{ id name }` ), {
            variables:   { id: projectId },
            skip:        !projectId,
            fetchPolicy: 'network-only'
        } );

    const isLoading = ( props.loading || queriesLoading( getProjectVersionReq ) ),
          options   = [] as IFormatOptionValue[];

    if( queriesHaveData( getProjectVersionReq ) ){

        const project = _.first( getProjectVersionReq.data.projects );

        ( project?.projectVersions ?? [] ).map( ( projectVersion ) => {
            options.push(
                formatOption( projectVersion.id, projectVersion.name )
            );
        } );
    }

    return (
        <SelectField
            { ...props }
            loading={ isLoading }
            options={ options }>
        </SelectField>
    );
};

Dropdown.defaultProps = defaultProps;

export { Dropdown as ProjectVersionDropdown };
